import i18n from '../../../../i18n'

export const PDF_VIEWER_LOCALIZATION = {
  attachment: {
    clickToDownload: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('attachment.clickToDownload'),
    noAttachment: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('attachment.noAttachment'),
  },
  bookmark: {
    noBookmark: i18n.getFixedT(i18n.language, 'pdf')('bookmark.noBookmark'),
  },
  core: {
    askingPassword: {
      requirePasswordToOpen: i18n.getFixedT(
        i18n.language,
        'pdf',
      )('core.askingPassword.requirePasswordToOpen'),
      submit: i18n.getFixedT(
        i18n.language,
        'pdf',
      )('core.askingPassword.submit'),
    },
    wrongPassword: {
      submit: i18n.getFixedT(i18n.language, 'pdf')('core.wrongPassword.submit'),
      tryAgain: i18n.getFixedT(
        i18n.language,
        'pdf',
      )('core.wrongPassword.tryAgain'),
    },
    pageLabel: i18n.getFixedT(i18n.language, 'pdf')('core.pageLabel'),
  },
  defaultLayout: {
    attachment: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('defaultLayout.attachment'),
    bookmark: i18n.getFixedT(i18n.language, 'pdf')('defaultLayout.bookmark'),
    thumbnail: i18n.getFixedT(i18n.language, 'pdf')('defaultLayout.thumbnail'),
  },
  download: {
    download: i18n.getFixedT(i18n.language, 'pdf')('download.download'),
  },
  drop: {
    dragDropFile: i18n.getFixedT(i18n.language, 'pdf')('drop.dragDropFile'),
  },
  fullScreen: {
    enterFullScreen: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('fullScreen.enterFullScreen'),
    exitFullScreen: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('fullScreen.exitFullScreen'),
  },
  localeSwitcher: {
    switchLocale: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('localeSwitcher.switchLocale'),
  },
  open: {
    openFile: i18n.getFixedT(i18n.language, 'pdf')('open.openFile'),
  },
  pageNavigation: {
    enterPageNumber: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('pageNavigation.enterPageNumber'),
    goToFirstPage: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('pageNavigation.goToFirstPage'),
    goToLastPage: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('pageNavigation.goToLastPage'),
    goToNextPage: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('pageNavigation.goToNextPage'),
    goToPreviousPage: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('pageNavigation.goToPreviousPage'),
  },
  print: {
    cancel: i18n.getFixedT(i18n.language, 'pdf')('print.cancel'),
    preparingDocument: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('print.preparingDocument'),
    print: i18n.getFixedT(i18n.language, 'pdf')('print.print'),
  },
  properties: {
    author: i18n.getFixedT(i18n.language, 'pdf')('properties.author'),
    close: i18n.getFixedT(i18n.language, 'pdf')('properties.close'),
    creationDate: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('properties.creationDate'),
    creator: i18n.getFixedT(i18n.language, 'pdf')('properties.creator'),
    fileName: i18n.getFixedT(i18n.language, 'pdf')('properties.fileName'),
    fileSize: i18n.getFixedT(i18n.language, 'pdf')('properties.fileSize'),
    keywords: i18n.getFixedT(i18n.language, 'pdf')('properties.keywords'),
    modificationDate: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('properties.modificationDate'),
    pageCount: i18n.getFixedT(i18n.language, 'pdf')('properties.pageCount'),
    pdfProducer: i18n.getFixedT(i18n.language, 'pdf')('properties.pdfProducer'),
    pdfVersion: i18n.getFixedT(i18n.language, 'pdf')('properties.pdfVersion'),
    showProperties: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('properties.showProperties'),
    subject: i18n.getFixedT(i18n.language, 'pdf')('properties.subject'),
    title: i18n.getFixedT(i18n.language, 'pdf')('properties.title'),
  },
  rotate: {
    rotateBackward: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('rotate.rotateBackward'),
    rotateForward: i18n.getFixedT(i18n.language, 'pdf')('rotate.rotateForward'),
  },
  scrollMode: {
    horizontalScrolling: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('scrollMode.horizontalScrolling'),
    verticalScrolling: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('scrollMode.verticalScrolling'),
    wrappedScrolling: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('scrollMode.wrappedScrolling'),
  },
  search: {
    close: i18n.getFixedT(i18n.language, 'pdf')('search.close'),
    enterToSearch: i18n.getFixedT(i18n.language, 'pdf')('search.enterToSearch'),
    matchCase: i18n.getFixedT(i18n.language, 'pdf')('search.matchCase'),
    nextMatch: i18n.getFixedT(i18n.language, 'pdf')('search.nextMatch'),
    previousMatch: i18n.getFixedT(i18n.language, 'pdf')('search.previousMatch'),
    search: i18n.getFixedT(i18n.language, 'pdf')('search.search'),
    wholeWords: i18n.getFixedT(i18n.language, 'pdf')('search.wholeWords'),
  },
  selectionMode: {
    handTool: i18n.getFixedT(i18n.language, 'pdf')('selectionMode.handTool'),
    textSelectionTool: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('selectionMode.textSelectionTool'),
  },
  theme: {
    switchDarkTheme: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('theme.switchDarkTheme'),
    switchLightTheme: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('theme.switchLightTheme'),
  },
  thumbnail: {
    thumbnailLabel: i18n.getFixedT(
      i18n.language,
      'pdf',
    )('thumbnail.thumbnailLabel'),
  },
  toolbar: {
    moreActions: i18n.getFixedT(i18n.language, 'pdf')('toolbar.moreActions'),
  },
  zoom: {
    actualSize: i18n.getFixedT(i18n.language, 'pdf')('zoom.actualSize'),
    pageFit: i18n.getFixedT(i18n.language, 'pdf')('zoom.pageFit'),
    pageWidth: i18n.getFixedT(i18n.language, 'pdf')('zoom.pageWidth'),
    zoomDocument: i18n.getFixedT(i18n.language, 'pdf')('zoom.zoomDocument'),
    zoomIn: i18n.getFixedT(i18n.language, 'pdf')('zoom.zoomIn'),
    zoomOut: i18n.getFixedT(i18n.language, 'pdf')('zoom.zoomOut'),
  },
}
